import { Component, OnInit, OnDestroy } from '@angular/core';
import { Product } from '../../../order/models/product';
import { GiftCardStepService } from '../../services/giftcard-step.service';
import { environment } from '../../../../../environments/environment';
import { NotificationService } from '../../../general/services/notification.service';

@Component({
  selector: 'app-giftcard-custom',
  templateUrl: './giftcard-custom.component.html',
  styleUrls: ['./giftcard-custom.component.css']
})

export class GiftcardCustomComponent implements OnInit, OnDestroy {

  customPrice = 10;

  error: string;
  min: number;
  max: number;

  constructor(
    private giftcardStepService: GiftCardStepService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    if (this.error) {
      this.error = '';
    }

    this.giftcardStepService.giftCardCustomPrice = null;

    this.min = environment.globalSettings.minCustomGiftCard;
    this.max = environment.globalSettings.maxCustomGiftCard;
  }

  get unlimitedAmountMode(): boolean {
    return this.giftcardStepService.unlimitedAmount;
  }

  get customGiftCardProduct(): Product[] {
    return this.giftcardStepService.customGiftCardProduct;
  }

  onClick(price: number): void {
    if (!price) {
      this.notificationService.show(GiftcardCustomComponent.name, 'Enter amount between 10 & 500€');
      return;
    }

    price = typeof (price) === 'string' ? parseInt(price) : price;
    if (price >= this.min && price <= this.max) {
      this.giftcardStepService.giftCardCustomPrice = price;
      this.giftcardStepService.forward();
    } else {
      this.notificationService.show(GiftcardCustomComponent.name, 'Enter amount between 10 & 500€');
    }
  }

  ngOnDestroy(): void {
    this.notificationService.hide(GiftcardCustomComponent.name);
  }
}
